import { render, staticRenderFns } from "./PagesManager.vue?vue&type=template&id=67639be4"
import script from "./PagesManager.vue?vue&type=script&lang=js"
export * from "./PagesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports